import { api } from '@/api/endpoints';
import { tg } from '@/lib/telegram';

/**
 * Шарит карточку:
 *  1. Бэк готовит inline-message (фото + текст + inline-кнопка) и отдаёт prepared_message_id.
 *  2. Telegram.WebApp.shareMessage(id) открывает нативный "Send to…" со сверстанным сообщением.
 *  3. Fallback на t.me/share/url — для старых клиентов (<Bot API 7.10, июль 2024) или если бэк недоступен.
 */
export async function shareCard(cardId: string, fallback: { url: string; text: string }): Promise<void> {
  const w = tg();
  const supportsPrepared = !!w && typeof w.shareMessage === 'function';

  if (supportsPrepared) {
    try {
      const { data } = await api.cards.sharePrep(cardId);
      if (data.prepared_message_id) {
        await new Promise<void>(resolve => {
          w!.shareMessage(data.prepared_message_id, () => resolve());
        });
        return;
      }
    } catch {
      // Падаем в fallback ниже.
    }
  }

  // url= параметр не передаём — иначе Telegram продублирует ссылку сверху сообщения
  // (она уже есть внутри text как {{url}}). Передаём только text=, ссылка останется в теле.
  const link = `https://t.me/share/url?text=${encodeURIComponent(fallback.text)}`;
  w?.openTelegramLink(link);
}
